import React from 'react';

export default function ContentElementText(Element) {
  return (
    <div
      className="prose-sm md:prose dark:!text-foreground dark:prose-strong:text-foreground lg:px-32"
      dangerouslySetInnerHTML={{ __html: Element.text }}
    />
  );
}
